import script from "./topcard.vue?vue&type=script&lang=ts&setup=true"
export * from "./topcard.vue?vue&type=script&lang=ts&setup=true"

import "./topcard.vue?vue&type=style&index=0&id=234fb338&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-234fb338"]])

export default __exports__